(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[id^="before-after-"]').forEach((section) => {
    const sliderHandle = section.querySelector('.slider-handle');
    const sliderLine = section.querySelector('.slider-line');
    const beforeImage = section.querySelector('.before-image');
    const afterImage = section.querySelector('.after-image');
    const sliderContainer = section.querySelector('.slider-container');

    if (!sliderHandle || !sliderContainer) return;

    let isDragging = false;

    const initializeSlider = () => {
      sliderHandle.style.left = '50%';
      sliderLine.style.left = '50%';

      if (beforeImage) beforeImage.style.clipPath = `inset(0 50% 0 0)`;

      if (afterImage) afterImage.style.clipPath = `inset(0 0 0 50%)`;
    };

    const moveSlider = (clientX) => {
      const rect = sliderContainer.getBoundingClientRect();
      let offsetX = clientX - rect.left;

      if (offsetX < 0) offsetX = 0;
      if (offsetX > rect.width) offsetX = rect.width;

      const pct = (offsetX / rect.width) * 100;

      sliderHandle.style.left = pct + '%';
      sliderLine.style.left = pct + '%';

      if (beforeImage) beforeImage.style.clipPath = `inset(0 ${100 - pct}% 0 0)`;

      if (afterImage) afterImage.style.clipPath = `inset(0 0 0 ${pct}%)`;
    };

    const start = () => (isDragging = true);
    const stop = () => (isDragging = false);

    sliderHandle.addEventListener('mousedown', start);
    sliderLine.addEventListener('mousedown', start);

    window.addEventListener('mousemove', (e) => {
      if (isDragging) moveSlider(e.clientX);
    });

    window.addEventListener('mouseup', stop);

    sliderHandle.addEventListener('touchstart', start);
    sliderLine.addEventListener('touchstart', start);

    window.addEventListener('touchmove', (e) => {
      if (isDragging) moveSlider(e.touches[0].clientX);
    });

    window.addEventListener('touchend', stop);

    initializeSlider();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
